import React from 'react'
import css from './style.scss'
import moment from 'moment'
import {FullContainer} from 'components/container'

import StoriesList from 'components/account_page/stories/list/index'
import Stats from 'components/account_page/stats/stats'


const NoStories=(props)=>(
  <FullContainer>
  <h3>This adventure doesn't have any story...</h3>
  </FullContainer>
)


export default (props)=>(
  <div className={css.content}>
    <h3>Stories in this adventure</h3>
    {props.stories.length>0 &&
      <div>
        <StoriesList
          miniStats
          withFullDate
          {...props.selectOpt}
          stories={props.stories}
        />
        {props.stats &&
          <div>
            <h3>Stats</h3>
            <Stats
              stories={props.stories}
              adventure={true}
              shared={props.shared}
              account_name={props.account_name}
              startDate={moment(props.stories[0].posted_at)}
              endDate={moment(props.stories[props.stories.length-1].posted_at)}
            />
          </div>
        }

      </div>
    }
    {props.stories.length===0 && <NoStories/>}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/adventures/stories.js